import {UyapRequest} from "./UyapRequest";

export interface DosyaTarafKaydetTalep {
    dosyaId: string,
    uyapIslemTur: 5,//
    TarafList: any[]
    //[{"tarafSifati":{"rolID":26,"rolAdi":"ÜÇÜNCÜ ŞAHIS"},"sorguTuru":0,"tarafTuru":"KISI","temelBilgileri":{"olumKaydi":false,"isAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","sorguTuru":0,"kisiKurumID":240014586,"tcKimlikNo":"36280238192","adi":"NİLAY","soyadi":"AYDOĞMUŞ","babaAdi":"HÜSEYİN","anaAdi":"ZELİHA","dogumTarihiStr":"25/10/1998","cinsiyeti":"K","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"mernisAdresiKullan":true}]
}

export interface DosyaTarafKaydetCevap {
}

export default class DosyaTarafKaydet extends UyapRequest<DosyaTarafKaydetTalep, DosyaTarafKaydetCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya taraf kaydediliyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return {
            "errorCode": "PRTL_GNL_1-1",
            "error": "Avukat Portal Talep Ekranında Taraf Bilgisi Kaydedilirken hata oluştu "
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'avukatPortalDosyaTarafKaydet.ajx';
    }

    async parse(data: any): Promise<DosyaTarafKaydetCevap> {
        return data;
    }

}

